var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRainbow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 39,
    viewBox: "0 0 79 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5 12.1648C54.5107 12.1648 66.6792 24.1794 66.6792 39H59.7372C59.7372 27.9648 50.6767 19.019 39.5 19.019C28.3233 19.019 19.2628 27.9648 19.2628 39H12.3208C12.3208 24.1793 24.4893 12.1648 39.5 12.1648Z",
    fill: "#9D48B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5 0C61.3152 1.88301e-06 79 17.4609 79 39H72.058C72.058 21.2463 57.4813 6.85413 39.5 6.85413C21.5187 6.85413 6.942 21.2463 6.942 39H0C1.90715e-06 17.4609 17.6848 -1.88301e-06 39.5 0Z",
    fill: "#9D48B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5 23.7767C48.0154 23.7767 54.9184 30.5924 54.9184 39H47.9764C47.9764 34.3779 44.1814 30.6309 39.5 30.6309C34.8186 30.6309 31.0236 34.3778 31.0236 39H24.0816C24.0816 30.5924 30.9846 23.7767 39.5 23.7767Z",
    fill: "#9D48B3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainbow);
export default __webpack_public_path__ + "static/media/Rainbow.3f6abb7343ea5fca23d086a17ecfea69.svg";
export { ForwardRef as ReactComponent };